import React from "react";
import { Grid, Icon, Panel, classnames } from "@culturehq/components";

import styles from "./EventForm.module.scss";

type EventFormProps = {
  children: React.ReactNode;
  icon: React.ComponentProps<typeof Icon>["icon"];
  title: string;
};

const EventForm: React.FC<EventFormProps> = ({ children, icon, title }) => (
  <div className={classnames(styles["event-sec"], "event-sec")}>
    <Panel className={classnames(styles["event-panel"], "event-panel")}>
      <Panel.Body>
        <Grid>
          <Grid.Item xs={2} md={1}>
            <div className={classnames(styles["img-sec"], "img-sec")}>
              <Icon icon={icon} />
            </div>
          </Grid.Item>
          <Grid.Item xs={10} md={false}>
            <h3>{title}</h3>
          </Grid.Item>
          <Grid.Item xs={12} md={11}>
            <h3 className="m_hide">{title}</h3>
            {children}
          </Grid.Item>
        </Grid>
      </Panel.Body>
    </Panel>
  </div>
);

export default EventForm;
